import React, { useEffect, useState } from 'react';
import { ReactComponent as CloseIco } from "../../../assets/icons/main/orderList-close.svg";
import { ReactComponent as PenIco } from "../../../assets/icons/main/orderList-pen.svg";
import { ReactComponent as DoneIco } from "../../../assets/icons/main/orderList-done.svg";
// import './OrderList.css';
import axios from "axios";
import { closeSnackbar, useSnackbar } from "notistack";
import { ReactComponent as LoginCross } from "../../../assets/icons/main/login-cross.svg";
import TPSLClose from "../../../assets/icons/main/NotifiClose.png";
import BuyInput from "../../../components/inputs/BuyInput";
import Button from "../../../components/button/Button";
import {roundFractional} from "../../../features/numberRounding";
import { useTranslation } from 'react-i18next';

const OrderList = (props) => {
    const {t} = useTranslation()
    const {
        id, size, avg, date, isLong, price, coin, coinfrom, amount, filled,
        total, action, chlen, marzha, margin, wasOpen, pnl, pnlPercent, leverage,
        takeProfit, stopLoss, requireUserData, requireUserBalance, isOpen, price_admin
    } = props;

    const { enqueueSnackbar } = useSnackbar();
    const actionSnackbar = snackbarId => (
        <button className="close-button" onClick={() => closeSnackbar(snackbarId)}>
            <LoginCross />
        </button>
    );

    const [orderActive, setOrderActive] = useState(false);
    const [TP, setTP] = useState(takeProfit);
    const [SL, setSL] = useState(stopLoss);

    const [stateTPSL, setStateTPSL] = useState(false)
    const [howChange, setHowChange] = useState(0) //0 - ничего, 1 - tp, 2 - sl, 3 - tp and sl

    // const [TP, setTP] = useState("");
    // const [SL, setSL] = useState("");

    useEffect(()=>{
        if(howChange == 0){
            setHowChange(1)
        }else if(howChange == 2){
            setHowChange(3)
        }
        console.log("TP");

    },[TP])
    useEffect(()=>{
        if(howChange == 0){
            setHowChange(2)
        }else if(howChange == 1){
            setHowChange(3)
        }
        console.log("LS");

    },[SL])

    useEffect(()=>{
        console.log(howChange, "howChange");
    },[howChange,TP,SL])

    const token = localStorage.getItem("token");
    const changeSL = () => {
        console.log({id, value: SL}, "change SL")
        axios.post("https://api-ru.fynex.cc/api/api/share/change/stop_loss", { id: String(id), value: String(SL) }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            console.log(res, "SL");
            setSL("");
            requireUserData();
        }).catch((e)=>{
            console.log(e);

        });
    };

    const changeTP = () => {
        console.log({id, value: TP}, "change TP")
        axios.post("https://api-ru.fynex.cc/api/api/share/change/take_profit", { id: String(id), value: String(TP) }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            console.log(res, "TP");
            setTP("");
            requireUserData();
        }).catch((e)=>{
            console.log(e);

        });
    };

    const closeOrder = () => {
        axios.post("https://api-ru.fynex.cc/api/api/share/close", { id, pnl, pnl_percent: pnlPercent, margin: margin }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(() => {
            requireUserData();
            requireUserBalance();
            enqueueSnackbar(t("orderList.orderClosed"), { action: actionSnackbar, autoHideDuration: 3000, variant: 'success', className: "snacksuccess" });
        }).catch(() => {
            enqueueSnackbar(t("orderList.errorOccurred"), { action: actionSnackbar, autoHideDuration: 3000, variant: 'error', className: "snackerror" });
        });
    };

    let leverageDecimal = 100 / leverage;
    let liquidationProm = price / 100 * leverageDecimal;
    let liquidationPrice = isLong ? price - liquidationProm : price + liquidationProm;



    return (
        <li className='OrderListActive'>
            {/* <div className={stateTPSL == true ? "tpsl-editBlockWrapper tpsl-editBlockWrapperActive" : "tpsl-editBlockWrapper"}>
                <div className={"tpsl-editBlock"}>
                    <div className="headline">
                        <h2>Редактирование лимитов</h2>
                        <img src={TPSLClose} alt="" onClick={()=>setStateTPSL(false)} />
                    </div>
                    <div className="inputs">
                        <BuyInput textData='USDT' placeholder='Тейк-профит' setInputChange={setTP} valueInput={TP} />
                        <BuyInput textData='USDT' placeholder='Стоп-лосс' setInputChange={setSL} valueInput={SL} />
                    </div>
                    <Button text={"Сохранить"} onClick={()=>{
                        if(howChange == 0){
                            enqueueSnackbar('Изменение нет', { action: actionSnackbar, autoHideDuration: 3000, variant: "error", className: "snackerror" });
                        }else if(howChange == 1){
                            ChangeTP()
                        }else if(howChange == 2){
                            ChangeSL()
                        }else if(howChange == 3){
                            ChangeTP()
                            ChangeSL()
                        }if(howChange != 0){
                            setStateTPSL(false)
                        }

                    }} />
                </div>
            </div> */}
            <div className="BTCUSDTdata">
                <div className="currency">
                    <div className={isLong ? "line line-green" : "line line-red"}></div>
                    <h2>{coinfrom}/{coin}</h2>
                    <div className="progression">{leverage}x</div>
                </div>
                <h3>{roundFractional(Number(size))}</h3>    {/*Размер*/}
                <h3>{roundFractional(Number(price))}</h3>   {/*цена входа*/}
                <h3>{roundFractional(Number(isOpen ? margin : marzha))} {coinfrom}</h3> {/*Маржа*/} 
                <h3>{roundFractional(Number(liquidationPrice))}</h3> {/*цена ликвидации*/}
                <h3 className={pnl >= 0 ? 'pnl pnl-green' : 'pnl pnl-red'}> {/*pnl*/}
                    {roundFractional(Number(pnl))} {coinfrom} ({roundFractional(Number(pnlPercent))}%)
                </h3>
                
                <h3>
                {
                    stateTPSL.TP ? 
                    <>
                        <input className='changeTPSL' type='text' value={TP} onChange={(e) => setTP(e.target.value)}/>
                        <DoneIco onClick={() => changeTP({SL: stateTPSL.SL, TP: false})}/>
                    </>
                    : 
                    <>
                        {TP}
                        <PenIco onClick={() => setStateTPSL({SL: stateTPSL.SL, TP: true})}/>
                    </>
                }
                </h3> {/*TP*/}

                
                <h3>
                {
                    stateTPSL.SL ? 
                    <>
                        <input className='changeTPSL' type='text' value={SL} onChange={(e) => setSL(e.target.value)}/>
                        <DoneIco onClick={() => changeSL({TP: stateTPSL.TP, SL: false})}/>
                    </>
                    : 
                    <>
                        {SL}
                        <PenIco onClick={() => setStateTPSL({TP: stateTPSL.TP, SL: true})}/>
                    </>
                }
                </h3> {/*TP*/}
            </div>
            <button className="cancel__buttonDEL" onClick={closeOrder}>{t('orderList.close')}</button>
        </li>
    );
};

export default OrderList;